import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedUiKitModule } from '@realwear-cloud/shared/ui-kit';
import { SharedUIModule } from './components/shared-ui.module';

@NgModule({
  imports: [CommonModule, SharedUIModule],
  exports: [SharedUiKitModule, SharedUIModule, CommonModule]
})
export class AlexandriaModule {}
